import * as THREE from 'three'
import {RectAreaLightUniformsLib} from 'three/addons/lights/RectAreaLightUniformsLib.js';
import CameraControls from 'camera-controls';
import removeObjectWithChildren from './utils/removeObjectWithChildren.js'


CameraControls.install({ THREE: THREE });
const clock = new THREE.Clock();



class ThreeViewer {
    
    constructor(params) {
        /**
         * This class is a wrapper for Three.js
         * @param {HTMLElement} params.element
         * @param {string} params.bgColor
         */
        
        this.params = params
        this.element = params.element
        this.isMobile = false 
        
        // Create width and height properties on the element
        this.clientWidth = this.element.clientWidth
        this.clientHeight = this.element.clientHeight
        
        // Mouse
        this.mouse = new THREE.Vector2()
        this.downMouse = new THREE.Vector2()
        this.intersection = {}
        this.isPinching = false // This is for mobile devices. This is used to check if the user is pinching or not.
        
        this.selectedSection = null
        this.selectedElement = null
        
        this.touchCount = 0
        window.threeViewer = this
    }
    
    
    addDummySketchPlane(size) {
        const zSize = Math.min(size.z, size.x)
        let plane = new THREE.Mesh(
            //new THREE.PlaneGeometry(2, 2),
            new THREE.BoxGeometry(2, 2, zSize),
            //new THREE.MeshBasicMaterial({color: 0xff0000, opacity: 0.5, transparent: true})
        );
        plane.euler = new THREE.Euler(0, 0, this.productSize.z)
        plane.type = "dummySketchPlane"
        plane.name = "dummySketchPlane"
        plane.position.y = 0;
        plane.position.z = 0;
        plane.position.x = 0;
        
        
        plane.layers.set(6); // 6 is the layer for the dummySketchPlane
        //plane.position.copy(this.center);
        //plane.rotation.copy(plane.euler);
        plane.visible = false//name === "Front"; // Set to true if you want to see the dummy plane
        this.scene.add(plane);
        this.addDummySketchPlane = plane
        //this.dummySketchPlane = plane
    }
    
    /*updateLightPosition() {
        // Update rect area light
        let cameraPos = this.camera.position.clone()
        let plot2DVector = new THREE.Vector2(cameraPos.x, cameraPos.z)
        plot2DVector.setLength(1)
        
        if (this.rectLight) {
            this.rectLight.position.x = plot2DVector.x
            this.rectLight.position.z = plot2DVector.y
            this.rectLight.lookAt(new THREE.Vector3(0, 0, 0))
        }
        
        
    }*/
    updateLightPosition() {
        // Update rect area light
        let cameraPos = this.camera.position.clone()
        let plot2DVector = new THREE.Vector2(cameraPos.x, cameraPos.z)
        const isLight = window.productColorObject.isLight
        const lightContrast = window.productColorObject.lightContrast
        
        
        plot2DVector.setLength(2)
        
        if (this.ambient) {
            this.ambient.position.x = plot2DVector.x
            this.ambient.position.z = plot2DVector.y
            this.ambient.position.y = -5
            this.ambient.lookAt(new THREE.Vector3(0, 0, 0))
            this.ambient.intensity = 3 * lightContrast //isLight ? 0.5 : 3
            //this.ambient.color = new THREE.Color(window.productColorObject.color)
        }
        if (this.directionalTop) {
            this.directionalTop.position.x = plot2DVector.x
            this.directionalTop.position.z = plot2DVector.y
            this.directionalTop.position.y = 5
            this.directionalTop.lookAt(new THREE.Vector3(0, 10, 0))
            this.directionalTop.intensity = 5 * lightContrast //isLight ? 0.5 : 5
        }
        if (this.pointLight) {
            this.pointLight.position.x = plot2DVector.x
            this.pointLight.position.z = plot2DVector.y
            this.pointLight.lookAt(new THREE.Vector3(0, 0, 0))
            this.pointLight.intensity = 8 //* lightContrast * (isLight ? 5 : 1)
        }
    }
    
    initViewer() {
        RectAreaLightUniformsLib.init() // TODO: Check if this is needed or not
        
        // Create scene, camera and renderer
        this.scene = new THREE.Scene()
        //this.scene.fog = new THREE.Fog(0xcccccc, 0, 5);
        
        // Create a camera, scene, renderer
        this.camera = new THREE.PerspectiveCamera(20, this.clientWidth / this.clientHeight, 0.1, 100)
        this.camera.position.set(0, 0, 0.5)
        this.camera.layers.enableAll()
        this.scene.add(this.camera)
        
        // Add rect area light
        const rectLight = new THREE.RectAreaLight(0xffffff, 25, 1.6, 10);
        rectLight.position.set(0, 0, 2);
        rectLight.lookAt(0, 0, 0);
        
        const pointLight = new THREE.PointLight(0xffffff, 8, 3);
        pointLight.layers.disableAll();
        pointLight.layers.enable(7);
        
        
        const ambient = new THREE.AmbientLight(0x404040, 5)
        this.scene.add(ambient);
        this.ambient = ambient
        
        const directionalTop = new THREE.DirectionalLight(0xffffff, 3);
        this.scene.add(directionalTop);
        this.directionalTop = directionalTop
        
        
        this.scene.add(pointLight);
        this.pointLight = pointLight
        //this.ambientLight = ambient
        
        
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true,
            gammaOutput: true,
            gamaFactor: 5.2,
            
        })
        this.renderer.shadowMap.enabled = true
        this.renderer.shadowMap.type = THREE.PCFSoftShadowMap;
        
        this.setWindowResize()
        
        this.element.appendChild(this.renderer.domElement)
        
        this.setUpCameraControls()
        
        window.addEventListener('resize', () => {
            this.setWindowResize()
        }, false);

        this.controls.addEventListener('update', () => {
            
            const quaternion = this.camera.quaternion.clone();
            const euler = new THREE.Euler().setFromQuaternion(quaternion, 'YXZ');
            
            this.addDummySketchPlane.rotation.y = euler.y
            
            this.updateLightPosition()
            
        })
        
        this.animate()
    }

    setUpCameraControls() {
        // Create controls
        this.controls = new CameraControls(this.camera, this.renderer.domElement)

        // Set up controls bounds
        this.controls.minPolarAngle = Math.PI * 0.2;
        this.controls.maxPolarAngle = Math.PI * 0.5//Math.PI * 0.5;
        this.controls.minDistance = 0.4;
        this.controls.maxDistance = 1.5;

        // Set up controls speed
        this.controls.azimuthRotateSpeed = this.isMobile ? 2.5 : 2
        this.controls.polarRotateSpeed = this.isMobile ? 2 : 1
        this.controls.dollySpeed = this.isMobile ? 4 : 2
        this.controls.draggingSmoothTime = 0

        // Set up controls actions for mouse and touch
        this.controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY
        this.controls.mouseButtons.left = CameraControls.ACTION.ROTATE
        this.controls.mouseButtons.right = CameraControls.ACTION.ROTATE
        this.controls.touches.two = CameraControls.ACTION.TOUCH_DOLLY
        this.controls.touches.three = CameraControls.ACTION.TOUCH_DOLLY_ROTATE
        this.controls.touches.one = CameraControls.ACTION.ROTATE

        this.controls.enableZoom = true;
        this.controls.touches.TWO = "ACTION.TOUCH_ZOOM"//THREE.TOUCH.DOLLY_ROTATE;  // Two-finger touch does zoom and pan
    }
    
    dispatchSceneEvent(inEvent, inData) {
        this.scene.dispatchEvent({type: inEvent, data: inData})
    }
    
    setWindowResize() {
        this.clientWidth = this.element.clientWidth
        this.clientHeight = this.element.clientHeight
        this.camera.aspect = this.clientWidth / this.clientHeight;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.clientWidth, this.clientHeight);
    }
    
    render() {
        const delta = clock.getDelta();
        const hasControlsUpdated = this.controls.update(delta);
        
        this.renderer.render(this.scene, this.camera);
    }
    
    animate() {
        // Schedule the next frame at the beginning
        this.animationFrameId = requestAnimationFrame(this.animate.bind(this));
        //console.log('animate')
        if (this.scene && this.camera) {
            // Perform rendering operations
            this.animateResetAndRenderScene();
        }
        
    }

    dispose() {
        window.cancelAnimationFrame(this.animationFrameId.current)
        this.controls.dispose()
        this.renderer.dispose()
        removeObjectWithChildren(this.scene)
        this.scene = null
        this.camera = null
        this.renderer = null
        this.controls = null
        this.pickingObjects = null
        this.timer = null
        this.delay = null
        this.prevent = null
        this.clock = null
        this.animationFrameId = null
    }
    
    animateResetAndRenderScene() {
        // Reset and render the normal scene
        this.renderer.render(this.scene, this.camera);
        this.render();
    }
    
    /**
     * Zoom to section
     * @param {*}       inSection
     * @param {
     * isAnimation      : Boolean   // Do we need animation or not
     * disableControls  : Boolean   // Do we need to disable controls or not after animation
     * fitObject        : Object3D  // Object to fit 'section or product'
     * animationTime    : number    // It is not animation time but we can adjust animation time by adjusting it
     * }                props
     * @returns
     */
    zoomToSection(inSection, props = {}) {
        return new Promise((resolve, reject) => {
            const main = this

            let isAnimation = props && Object.hasOwn(props, 'isAnimation') ? props.isAnimation : true

            if(props && Object.hasOwn(props, 'animationTime')) {
                if (props.animationTime === 0) {
                    isAnimation = false
                }else{
                    main.controls.smoothTime = props.animationTime
                }
            }

            // Get the radial angle of the section
            let angleSection = inSection.userData.radialAngle;
            // Create a vector pointing in the positive Z direction
            let v1 = new THREE.Vector3(0, 0, 1);
            // Rotate the vector around the Y axis by the specified angle
            v1.applyAxisAngle(new THREE.Vector3(0, 1, 0), angleSection);

            // Calculate the center of the bounding box of the section
            let center = new THREE.Vector3(0, 0, 0);
            inSection.geometry.computeBoundingBox();
            let bBox = inSection.geometry.boundingBox;
            bBox.getCenter(center);

            // Calculate the desired camera position based on the center and the rotated vector
            let cameraPos = center.clone().add(v1);

            let target = main.controls.getTarget().clone()
            // Target X & Z should be 0 for center rotation
            main.controls.setLookAt(cameraPos.x, cameraPos.y, cameraPos.z, 0, target.y, 0, isAnimation)
            
            //inSection.remove(inSection.dummySketchPlane)
            let options = {
                paddingTop: 0.01,
                paddingBottom: 0.01,
                paddingLeft: 0.01,
                paddingRight: 0.01
            }

            let fitObject = props && props.fitObject ? props.fitObject : inSection
            // To center the object in the screen
            // Remove the bracket and other things from the calculation of the box
            let box = new THREE.Box3().setFromObject(fitObject)
            // Find max value from min and max X and Z
            let max = Math.max(box.max.x, box.max.z, Math.abs(box.min.x), Math.abs(box.min.z))
            box.max.x = box.max.z = max
            box.min.x = box.min.z = -max

            main.controls.fitToBox(box, isAnimation, options).then(() => {
                let target = main.controls.getTarget().clone()
                //inSection.add(inSection.dummySketchPlane)
                main.controls.setTarget(0, target.y, 0, isAnimation).then(() => {
                    setTimeout(() => {
                        resolve()
                    }, 100);
                })
                main.controls.smoothTime = 0.25
                // Update rect area light
                let cameraPos = main.camera.position.clone()
                let plot2DVector = new THREE.Vector2(cameraPos.x, cameraPos.z)


                plot2DVector.setLength(1)
                main.rectLight.position.x = plot2DVector.x
                main.rectLight.position.z = plot2DVector.y

                main.rectLight.lookAt(new THREE.Vector3(0, 0, 0))

                if (!props) return
                
                if (!Object.hasOwn(props, 'disableControls')) return

                if (props.disableControls) {
                    this.controls.mouseButtons.wheel = CameraControls.ACTION.NONE
                    this.controls.mouseButtons.left = CameraControls.ACTION.NONE
                    this.controls.mouseButtons.right = CameraControls.ACTION.NONE
                    this.controls.enabled = false
                } else {
                    this.controls.mouseButtons.wheel = CameraControls.ACTION.DOLLY
                    this.controls.mouseButtons.left = CameraControls.ACTION.ROTATE
                    this.controls.mouseButtons.right = CameraControls.ACTION.TRUCK
                    this.controls.enabled = true
                }
            })
        })
    }
    
}

export { ThreeViewer };
